import React from "react"
import { Table } from "semantic-ui-react"
import Price from "components/Price/Price";
import { FrachtRow } from "theme/sandra/components/Cart/CartTotal"


const PositionRow = ( { position, product } ) => {
  const useProductData = product && product.extras
  return (
    <tr>
      <td>{position.article_nr}</td>
      <td><span className="f5">{position.desc}</span><br/>
        {useProductData && <div className="f6 black-60"><span className="">{product.extras.Farbe},</span> <span
          className="black-60 d6 ">{product.extras.Groesse}</span></div>}
      </td>
      <td className="tl">{position.count} {translate( "PU" )} <br/>
        <div className="black-60 d6 ">{position.count * position.unit_multi} {translate( "piece" )}</div>
      </td>
      <td className="tr"><Price>{position.price * position.unit_multi}</Price></td>
      <td className="tr"><Price>{position.sum}</Price></td>
    </tr>
  )
}

const SuccessTable = ( { positions, netto, byId } ) => {
  return (
    <Table>
      <colgroup>
        <col width="10%"/>
        <col width="45%"/>
        <col width="15%"/>
        <col width="15%"/>
        <col width="15%"/>
      </colgroup>

      <tbody>
      <tr>
        <th>{translate( "article" )}</th>
        <th>&nbsp;</th>
        <th className="tl">Anzahl</th>
        <th className="tr">{translate("Preis/VE")}</th>
        <th className="tr">Summe</th>
      </tr>

      {positions.map( ( position ) => {
        const product = byId[ position.article_id ]
        return <PositionRow key={position.article_id} position={position} product={product}/>
      } )}

      <tr>
        <td className="netto-sum tr" colSpan="7">Gesamtpreis netto: <Price>{netto}</Price></td>
      </tr>

      <FrachtRow sum={netto}/>
      </tbody>
    </Table>
  )
}

export default SuccessTable


// WEBPACK FOOTER //
// ./src/theme/sandra/components/Product/SuccessTable.js